"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castelnovo-del-friuli": {
    "dd5283c8": [{
      "hkey": "917090e5",
      "slug": "castelnovo-del-friuli",
      "name": "Castelnovo del Friuli",
      "primary": true,
      "skipSearch": false
    }],
    "molevana": [{
      "hkey": "917090e5",
      "slug": "castelnovo-del-friuli",
      "name": "Castelnovo del Friuli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "022f32dc": [{
      "hkey": "917090e5",
      "slug": "castelnovo-del-friuli",
      "name": "Castelnovo del Friuli",
      "primary": true,
      "skipSearch": false
    }],
    "praforte": [{
      "hkey": "917090e5",
      "slug": "castelnovo-del-friuli",
      "name": "Castelnovo del Friuli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d951c4a5": [{
      "hkey": "917090e5",
      "slug": "castelnovo-del-friuli",
      "name": "Castelnovo del Friuli",
      "primary": true,
      "skipSearch": false
    }],
    "vidunza": [{
      "hkey": "917090e5",
      "slug": "castelnovo-del-friuli",
      "name": "Castelnovo del Friuli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;